/**
     * @desc 获得一个唯一id
调用合约之前，需要产生的id，用该接口产生，该接口产生的id可以实现后端快速排序，合约监听返回的数据中包含该id，用于区分监听返回的数据
     */

import * as defs from '../../baseClass';
import { PontCore } from '../../pontCore';
import * as ajax from '../../../utils/request';

export class Params {}

export const init = new defs.Result();

export function request(params, options = {}) {
  return ajax.post('/system/getId', params);
}

export function upload(params, options = {}) {
  return ajax.upload('/system/getId', params);
}
